<template>
    <div class="vehicles-slider__cards" ref="vehiclesCardsSlider" :class="{ 'swiper': isSlider }">
        <ul class="vehicles-slider__list" :class="{ 'swiper-wrapper': isSlider }">
            <VehicleCard v-for="vehicle in vehicles" :key="vehicle.id" :vehicle="vehicle" :vehicleNodeId="vehicleNodeId" />
        </ul>
    </div>
</template>
<script>

import VehicleCard from './components/vehicleCard.vue';
import Swiper from 'swiper';
import  { Navigation, Pagination } from "swiper/modules";
Swiper.use([Navigation, Pagination ]);
import SwiperHelpers from './../partials/swiperHelpers.js';
export default {
    name: "VehiclesSortedSet",
    props: ['vehicleNodeId', 'sortBy', 'take', 'isSlider',  'componentId','productId','productVariantId'],
    components: {
        VehicleCard
    },
    data() {
        return {
            dictionary: [],
            vehicles: [],
            swiper: null,
        };
    },
    created() {
        const vm = this;
        vm.culture = document.querySelector("html").getAttribute("lang");
        var object = {
            vehicleNodeId: vm.vehicleNodeId,
            type: vm.sortBy,
            displayedAtLocation: 'Vehicles Sorted Set',
            isSlider: vm.isSlider,
            take: vm.take,
            culture: vm.culture
        }

        var endpoint = '/umbraco/api/ProductSearchApi/GetSortedSet?';

        if(vm.sortBy.toLowerCase() == "similar") {
            endpoint = '/umbraco/api/ProductSearchApi/GetProductRecommendation?';
            object.productId = vm.productId;
            object.variantId = vm.productVariantId;
        }

        fetch(endpoint + new URLSearchParams(object)).then((response) => response.json())
            .then(data => {
                vm.vehicles = data;
                if (vm.isSlider) {
                    vm.swiper = new Swiper(vm.$refs.vehiclesCardsSlider, {
                        speed: 500,
                        loop: false,
                        slidesPerView: 1,
                        pagination: {
                            el: '#' + vm.componentId + " .slider-pagination",
                            type: 'bullets',
                            clickable:true
                        },
                        breakpoints: {
                            // when window width is >= 625px
                            625: {
                                slidesPerView: 2,
                            },
                            // when window width is >= 1125px
                            1125: {
                                slidesPerView: 3,
                            }
                        },
                        spaceBetween: 30,
                        navigation: {
                            nextEl: '#' + vm.componentId + " .slider-navigation__next",
                            prevEl: '#' + vm.componentId + " .slider-navigation__prev",
                        },
                        on: {
                            slideChange: () => {
                                SwiperHelpers.handleSlideChange();
                            },
                            slideChangeTransitionEnd: (swiper) => {
                                SwiperHelpers.handleSlideChangeTransitionEnd(swiper);

                            }
                        }
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });

    }
};
</script>
